/**
 * @description 비밀번호 입력 사양을 충족하는지 체크하는 함수
 *              숫자 영문 특수기호(!@#$%^*()-_=+|[]{};:,.<>/?)를 모두 포함하여 8-16자 이상
 * @returns boolean, (true: 사양을 만족함, false: 사양을 만족하지 않음)
 */

const validateAuthPassword = (str: string) => {
  // 숫자/영문 포함하고 8-16자 이내
  const REGEX_NUMBER_AND_LETTERS = /^(?=.*[a-zA-Z])(?=.*\d).{8,16}$/g;
  if (!REGEX_NUMBER_AND_LETTERS.test(str)) {
    return false;
  }

  // 숫자/영문 제거
  const REGEX_NUMBER_AND_ALPHABET = /[\da-zA-Z]+/g;
  const onlySpecialCharacters = str.replaceAll(REGEX_NUMBER_AND_ALPHABET, '');

  // 허용하는 특수문자 1개 이상 포함
  const SPECIAL_SYMBOLS = '!@#$%^*()-_=+|[]{};:,.<>/?';
  if (!onlySpecialCharacters.length) {
    return false;
  }

  for (const specialCharacter of onlySpecialCharacters) {
    if (!SPECIAL_SYMBOLS.includes(specialCharacter)) {
      return false;
    }
  }

  return true;
};

export default validateAuthPassword;
